module.exports = __webpack_public_path__ + "static/img/frame.5512c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frame.png
// module id = FUQ/
// module chunks = 8